import { paginationOptions, navigationOptions } from "Config/slider/default"
import { productsSliderOptions } from "Config/slider/product"
import { indexSliderOptions, indexTestimonialsOptions } from "Config/slider/index"

import { rSwiperVisibleItems } from 'Functions/swiper-visible-items'
import { rSwiperCssNavFix } from 'Functions/swiper-css-nav-fix'
import { Grid, Pagination, Navigation } from 'swiper';
import { productAccessoriesOptions } from "./accessories";

export const sliderOptions = instance => {
    // default options
    let options = {
        simulateTouch: false,
        watchOverflow: true,
        preventInteractionOnTransition: true,
        roundLengths: true,
        modules: [Grid, Pagination, Navigation, rSwiperVisibleItems, rSwiperCssNavFix]
    }

    if (instance.paginationEl) {
        options = {...options, ...paginationOptions(instance)}
    }

    if (instance.prevEl && instance.nextEl) {
        options = {...options, ...navigationOptions(instance)}
    }

    if (instance.hasAttribute('r-slider-index-banner')) {
        options = {...options, ...indexSliderOptions(instance)}
    }

    if (instance.hasAttribute('r-slider-products')) {
        options = {...options, ...productsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-accessories')) {
        options = {...options, ...productAccessoriesOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-testimonials')) {
        options = {...options, ...indexTestimonialsOptions(instance, options)}
    }

    return {...options, ...instance.customOptions}
}